module.exports = __webpack_public_path__ + "img/hektor.954ee876.jpg";